import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const LOGO_HEIGHT = 24;

const StyledImg = styled.img`
  user-select: none;
  pointer-events: none;
  width: auto;
  height: ${LOGO_HEIGHT}px;
`;

const Logo = ({ customLogo, customName = 'Kizen' }) => {
  const { t } = useTranslation();
  const alt = t('{{name}} Logo', { name: customName });
  return (
    <StyledImg
      src={customLogo || '/images/kizen-word-mark.svg'}
      height={LOGO_HEIGHT}
      width="auto"
      role="button"
      tabIndex={0}
      aria-label={alt}
      alt={alt}
      className="KizenLogo"
    />
  );
};

export default Logo;
